// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_HOMEPAGE = "Zp\u011bt na hlavn\u00ed str\u00e1nku";
export const BLOGS_SEARCH_PLACEHOLDER = "Hledej na zdi";
export const HOMEPAGE_PR_ARTICLES_TITLE = "\u010cl\u00e1nky od na\u0161ich partner\u016f";
export const NO_SEARCH_RESULTS_FOR = "Nena\u0161li se \u017e\u00e1dn\u00e9 v\u00fdsledky vyhled\u00e1v\u00e1n\u00ed pro slovo";
export const PB_MENU_MY_ACTIVITY = "Zapojila jsem se";
export const SEARCH_RESULTS_FOR = "V\u00fdsledky vyhled\u00e1v\u00e1n\u00ed pro slovo";
